import { TProduct } from '@src/app/shared/types/common';
import { environment } from '@src/environments/environment';

export const productIds: Record<number, TProduct> = {
  3: {
    loans: 6,
    deposits: 8,
    cards: 32,
    accounts: 548,
    packages: environment.packagesRouteId,
    digital: 38,
    more: 39,
  },
  4: {
    loans: 7,
    deposits: 40,
    cards: 41,
    accounts: 549,
    acquiring: environment.acquiringRouteId,
    digital: 42,
    more: 43,
  },
  5: {
    loans: 44,
    cards: 46,
    digital: 47,
    more: 48,
  },
} as const;
